<template>
    <div style="padding: 0 0 6px 0">
        <div v-if="options.length === 0" style="height: calc(100vh - 350px); display: flex; justify-content: center; align-items: center">
            <div style="text-align: center;" class="f15 grey--text text--darken-3">
                {{ $t('plan_calculator.no_treatment_on_this_jaw') }}
            </div>
        </div>
        <div v-else-if="demoPrices" class="demo-prices-notification">
            <div @click="$router.push('pricelist')" class="pink lighten-2 white--text" style="text-align: center; font-size: 12px; border-radius: 7px; padding: 6px 12px; margin: 0 16px 0px 16px;" v-html="$t('welcome.demo_prices_desc')"></div>
        </div>
        <v-layout row wrap style="padding: 0 8px;">
            <v-flex v-for="(optionGroup, g) in options" :key="'optGroup_' + g" style="padding: 0 8px 0 8px;" :class="'xs' + columns" class="treatment-option-column">
                <div v-for="(option, i) in optionGroup.options" :key="'option_' + g + '_' + i" group leave-absolute>
                    <pm-treatment-option-selector-button
                        v-if="!limitOptions || i<limit"
                        :columns="options.length"
                        :id="`treatment-option-selector--${i}`"
                        :key="option.state_id + option.selected"
                        :amount="optionGroup.amount"
                        :pid="optionGroup.pid"
                        :value="option"
                        :optionGroup="optionGroup"
                        @click.native="handleClick(option, optionGroup.steps)"
                    />
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<style>
    .demo-prices-notification u {
        font-weight: 600!important;
    }

.demo-prices-notification {
    padding: 0 0 16px 0 !important;
}

@media (min-width: 700px) {
    .demo-prices-notification {
        padding: 0 0 16px 0 !important;
        font-size: 16px !important;
    }

    .demo-prices-notification div {
        padding: 10px 0 !important;
        font-size: 16px !important;
    }
}
</style>

<script>
import PmTreatmentOptionSelectorButton from "./treatment-option-selector-button";
import PlanOptionService from "../../extensions/services/plan-option-service";
export default {
    props: {
        jaw: {
            type: String,
            default: "upper",
        },
        steps: {
            type: Object,
            default: () => {
                return ([]);
            },
        },
        selectedRegion: {
            type: Number,
            default: 0,
        },
    },
    components: {
        PmTreatmentOptionSelectorButton,
    },
    data() {
        return ({
            limit: 99,
            limitOptions: true,
            columns: 2,
            demoPrices: false,
        });
    },
    created() {
        this.options = PlanOptionService.getOptions(this.selectedRegion, this.steps);
        this.columns = 12 / this.options.length;

        this.registerBusEvent("reset/jaw", () => {
            this.options = PlanOptionService.getOptions(this.selectedRegion, this.steps);
            this.columns = 12 / this.options.length;
        });

         if (localStorage.getItem("demoPrices") === null) this.demoPrices = true;

         this.checkZeroPrices();
    },
    methods: {
        checkZeroPrices() {
            try {
                this.options.forEach(option => {
                    option.options.forEach(o => {
                        if (isNaN(parseInt(o.price)) || parseInt(o.price) === 0) {
                            this.demoPrices = true;
                        }
                    });
                });
            } catch(error) {
                captureException(error);
            }
        },
        handleClick(option, steps) {
            this.selectOption(option, steps);
            this.updateTotal();
            this.$set(this.$store.state.simplePlan, "emailSent", false);
        },
        handleUnselectableSteps(option) {
            if (typeof option.unselectable === "undefined" || !option.unselectable) return;
            this.steps.forEach((step) => {
                if (option.jaw !== step.jaw) return;
                if (typeof step.unselectable === "undefined" || !step.unselectable) return;
                step.animate = option.selected;
            });
        },
        selectOption(option, steps) {
            if (parseInt(option.state_pid) !== 315 && parseInt(option.selected) === 1) {
                if (typeof option.unselectable === "undefined" || !option.unselectable) return;
            }

            if (option.isProtocolVariation && option.fullJaw) {
                const id = option.id;
                steps.forEach((step) => {
                    if (step === null) return;
                    step.options.forEach((option) => {
                        option.selected = (id === option.id) ? (option.isProtocolVariation ? 1 : 1 - option.selected) : 0;
                    });
                });
            } else {
                const id = option.state_id;
                steps.forEach((step) => {
                    if (step === null) return;
                    step.options.forEach((option) => {
                        option.selected = (id === option.state_id) ? (option.isProtocolVariation ? 1 : 1 - option.selected) : 0;
                    });
                });
            }
            this.handleUnselectableSteps(option);
            this.$forceUpdate();
            this.$emit('updated');
        },
        updateTotal() {
            this.$set(this.$store.state.simplePlan, this.jaw + "JawTotal", this.$store.getters["simplePlan/totalForJaw"](this.jaw, true));
        },
    },
};
</script>
